import { defaultTextSize } from '../defaults';
import { getMobileLineHeightClassName } from '../build-global-css';
import { isPixelValue } from '../line-height-to-px';
import { calculateLineHeightInPx } from '../inject-mobile-line-height-class';
import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getStyleProp } from './css-property-utils';
export const injectMobileLineHeightClass = (el, props) => {
    const pixelValueLineHeight = getLineHeightInPx(el, props);
    if (pixelValueLineHeight) {
        const mobileLineHeight = toMobileFontSize(pixelValueLineHeight);
        el.addClass(getMobileLineHeightClassName(mobileLineHeight));
    }
};
export function getLineHeightInPx(el, props) {
    const lineHeight = getStyleProp(el, 'line-height', props.css) || (props || {}).lineHeight;
    const originalLineHeight = getStyleProp(el, 'original-line-height', props.css) ||
        (props || {}).lineHeight;
    const fontSize = getStyleProp(el, 'font-size', props.css) || (props || {}).fontSize;
    return [
        {
            condition: lineHeight && isPixelValue(lineHeight),
            getLineHeight: () => lineHeight,
        },
        {
            condition: lineHeight && !isPixelValue(lineHeight) && fontSize,
            getLineHeight: () => calculateLineHeightInPx(lineHeight, fontSize) || defaultTextSize,
        },
        {
            condition: originalLineHeight && fontSize,
            getLineHeight: () => calculateLineHeightInPx(originalLineHeight, fontSize) ||
                defaultTextSize,
        },
    ].reduce((resultingLineHeight, matcher) => {
        if (!resultingLineHeight && matcher.condition) {
            return matcher.getLineHeight();
        }
        return resultingLineHeight;
    }, null);
}
//# sourceMappingURL=inject-mobile-line-height-class.js.map